import { useRouter } from "next/router";
import { InputText } from "primereact/inputtext";
import { useTranslation } from "react-i18next";
import { Typography } from "../../../../common/components";
import { Modal } from "../../../../common/components/Modal";
import { FLOW_TYPES, STEPS } from "../../constants";
import { useSetUpSpacesStore } from "../../store";
import { DialogStepper } from "../DialogStepper";

const SetUpLocation = () => {
    const { toggleVisibility, setStep, location, setLocation, flowType } =
        useSetUpSpacesStore();

    const { t } = useTranslation(["common", "setUpSpaces"]);

    const router = useRouter();
    const { companyId } = router.query as { companyId: string };

    const companyAdminIsAddingLocation =
        companyId && flowType === FLOW_TYPES.ADD_LOCATION;
    const isEmptyValue = !location?.trim();

    const handleClickNext = () => {
        if (isEmptyValue) {
            return;
        }

        setStep(STEPS.SET_ADDRESS);
    };

    const handleClickBack = () => {
        if (flowType === FLOW_TYPES.ADD_LOCATION) {
            setStep(STEPS.SELECT_COMPANY);
        } else {
            setStep(STEPS.SET_COMPANY);
        }
    };

    return (
        <Modal
            title={t("setUpSpaces:location.title") || ""}
            isOpen
            hasOkButton
            hasCancelButton={!companyAdminIsAddingLocation}
            cancelText={t("common:back") || ""}
            isOkButtonDisabled={isEmptyValue}
            okText={t("common:next") || ""}
            onClickOk={handleClickNext}
            onClickClose={toggleVisibility}
            onClickCancel={handleClickBack}
            className="max-w-full"
        >
            <div className="flex flex-col gap-4">
                <DialogStepper activeStep={STEPS.SET_LOCATION} />
                <Typography>{t("setUpSpaces:location.question")}</Typography>
                <div>
                    <label>{t("common:name")}*</label>
                    <InputText
                        className="w-full"
                        value={location}
                        onChange={(e) => {
                            setLocation(e.target.value);
                        }}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default SetUpLocation;
